'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNodeWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _h = require('./hyperscript/h');

var _classNameFromVNode = require('snabbdom-selector/lib/classNameFromVNode');

var _classNameFromVNode2 = _interopRequireDefault(_classNameFromVNode);

var _selectorParser2 = require('snabbdom-selector/lib/selectorParser');

var _selectorParser3 = _interopRequireDefault(_selectorParser2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VNodeWrapper = exports.VNodeWrapper = function () {
  function VNodeWrapper(rootElement) {
    _classCallCheck(this, VNodeWrapper);

    this.rootElement = rootElement;
  }

  _createClass(VNodeWrapper, [{
    key: 'call',
    value: function call(vnode) {
      // eslint-disable-line complexity

      var _selectorParser = (0, _selectorParser3.default)(vnode.sel);

      var selectorTagName = _selectorParser.tagName;
      var selectorId = _selectorParser.id;

      var vNodeClassName = (0, _classNameFromVNode2.default)(vnode);
      var vNodeData = vnode.data || {};
      var vNodeDataProps = vNodeData.props || {};
      var _vNodeDataProps$id = vNodeDataProps.id;
      var vNodeId = _vNodeDataProps$id === undefined ? selectorId : _vNodeDataProps$id;


      var isVNodeAndRootElementIdentical = vNodeId.toLowerCase() === this.rootElement.id.toLowerCase() && selectorTagName.toLowerCase() === this.rootElement.tagName.toLowerCase() && vNodeClassName.toLowerCase() === this.rootElement.className.toLowerCase();

      if (isVNodeAndRootElementIdentical) {
        return vnode;
      }

      var _rootElement = this.rootElement;
      var tagName = _rootElement.tagName;
      var id = _rootElement.id;
      var className = _rootElement.className;


      var elementId = id ? '#' + id : '';

      var elementClassName = className ? '.' + className.split(' ').join('.') : '';

      return (0, _h.h)('' + tagName + elementId + elementClassName, {}, [vnode]);
    }
  }]);

  return VNodeWrapper;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/VNodeWrapper.js
 **/